import React from "react";
import { Column, DualAxes } from "@ant-design/plots";

const ChartCompareTestInside = ({ data }) => {
  const mapDataColumn = () => {
    const mappedData = [];

    data?.forEach((item) => {
      const monthName = `Tháng ${item.thang}`;
      item.thongKeBenTrong.forEach((x) => {
        mappedData.push({
          month: monthName,
          count: Number(x.noFarm),
          name: x.subType + " số lượng trại",
          label: x.subType,
          type: "count",
        });
      });
    });
    return mappedData;
  };
  const mapDataLine = () => {
    const mappedData = [];

    data?.forEach((item) => {
      const monthName = `Tháng ${item.thang}`;
      item.thongKeBenTrong.forEach((x) => {
        mappedData.push({
          month: monthName,
          avgMark: Number(x.avgMark),
          name: x.subType + " điểm trung bình",
          label: x.subType,
          type: "avgMark",
        });
      });
    });
    return mappedData;
  };

  const columnData = mapDataColumn();
  const lineData = mapDataLine();
  const calcPercentWithPrevMonth = (data) => {
    if (data.month === "Tháng 1") return "";
    const findDataPrevMonth = lineData?.find((x) => {
      return (
        Number(data.month.replace("Tháng ", "")) -
          Number(x.month.replace("Tháng ", "")) ===
          1 && x.label === data.label
      );
    });
    const percentPrev =
      Number(findDataPrevMonth.avgMark) - Number(data.avgMark);

    return `<div style="display: flex; align-items: center"><p>${
      percentPrev < 0
        ? '<span style="display: inline-block; font-size: 20px; color: #00ff33">↑</span> Tăng'
        : '<span style="display: inline-block; font-size: 20px; color: #fa0000">↓</span> Giảm'
    }<span > ${Math.abs(percentPrev).toFixed(
      2
    )}% so với tháng trước </span></p></div>`;
  };
  const config = {
    data: [columnData, lineData],
    height: 600,
    xField: "month",
    yField: ["count", "avgMark"],
    yAxis: [
      {
        min: 0,
        tickInterval: 10,
      },
      {
        min: 0,
        tickInterval: 10,
      },
    ],
    legend: {
      position: "bottom",
      offsetY: 20,
      itemName: {
        formatter: (text, item, index) => {
          return item.name;
        },
      },
    },
    tooltip: {
      shared: false,
      showMarkers: true,

      customContent: (title, items) => {
        return `<div style="padding: 10px;">
                      <h4>${title}</h4>
                      ${items
                        .map((item) =>
                          item.data.type === "avgMark"
                            ? `<div><p style="margin-top: 15px;font-size: 24px">${
                                item.value
                              }%</p> <div>${calcPercentWithPrevMonth(
                                item.data
                              )}</div></div>`
                            : `<div>
                              <div>
                                <p style="font-size: 14px; margin-bottom:5px">${item.name}</p>
                               <div style="display:flex; align-items:center">
                               ${
                                 item.data.label === "Risk"
                                   ? '<div style="width:18px; height:18px; border-radius: 4px; margin-right: 5px; background-color: #F65C00;"></div>'
                                   : item.data.label === "Buffer"
                                   ? '<div style="width:18px; height:18px; border-radius: 4px; margin-right: 5px; background-color: #5CC8BE;"></div>'
                                   : '<div style="width:18px; height:18px; border-radius: 4px; margin-right: 5px; background-color:#0E42D2"></div>'
                               }
                               <p style="font-size: 20px; margin:0px">${
                                 item.value
                               }</p>
                               </div>
                              </div>
                            </div>`
                        )
                        .join("")}
                    </div>`;
      },
    },

    geometryOptions: [
      {
        geometry: "column",
        isGroup: true,
        seriesField: "name",
        color: ({ name }) => {
          if (name.includes("Clean")) return "#0095FF";
          if (name.includes("Buffer")) return "#5CC8BE";
          return "#F7BA1E";
        },
        label: {
          position: "middle",
          style: {
            fill: "#FFFFFF",
            opacity: 0.8,
            fontSize: 12,
          },
        },
      },
      {
        geometry: "line",
        seriesField: "name",
        lineStyle: ({ name }) => {
          if (name.includes("Buffer")) {
            return {
              opacity: 1,
              stroke: "#5CC8BE",
            };
          }

          if (name.includes("Clean")) {
            return {
              opacity: 1,
              stroke: "#0E42D2",
            };
          }
          if (name.includes("Risk")) {
            return {
              opacity: 1,
              stroke: "#F7BA1E",
            };
          }
        },
      },
    ],
  };

  return <DualAxes {...config} />;
};
export default ChartCompareTestInside;
